import { Component } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { Router } from '@angular/router';

export interface IConfirmDialogModel {
    title: string;
    subTitle: string;
    message: string;

}

@Component({
    selector: 'confirm-dialog',
    styleUrls: ['./confirm.dialog.css'],
    templateUrl: './confirm.dialog.html'
})
export class ConfirmDialog extends DialogComponent<IConfirmDialogModel, boolean> implements IConfirmDialogModel {

    title: string;
    subTitle: string;
    message: string;

    constructor(dialogService: DialogService, public router: Router) {
        super(dialogService, router);
    }

    confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = true;
        this.close();
    }
}
